exports = module.exports = require("../../../../../../../../css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../../../../../css-loader/index.js!datatables.net-dt/css/jquery.dataTables.min.css"), "");

// module
exports.push([module.id, ".enhanced-tabular-question-context {\n  width: 100%; }\n  .enhanced-tabular-question-context table thead tr th {\n    text-align: center; }\n  .enhanced-tabular-question-context .dataTables_wrapper, .enhanced-tabular-question-context #sort-dropdown {\n    margin-bottom: 20px; }\n  .enhanced-tabular-question-context .disable-dt-sort.sorting {\n    background-image: none !important;\n    pointer-events: none; }\n    .enhanced-tabular-question-context .disable-dt-sort.sorting.sorting_asc, .enhanced-tabular-question-context .disable-dt-sort.sorting.sorting_desc {\n      background-image: none !important;\n      pointer-events: none; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./node_modules/@mprep/shared/lib/angular/components/question-view/question-context-view/enhanced-tabular-question-context/enhanced-tabular-question-context.scss
// module id = n8pH
// module chunks = 3